import {get, post} from "../core/api";
import {ConditionResultResponse} from "./ConditionResultResponse";

const extractBody = (res: Response) => res.json();

export const getConditions = (conditionResultRequest: string[]): Promise<ConditionResultResponse[]> => {
    return post('/monitoring/conditions', conditionResultRequest)
        .then(extractBody);
}
export const getConditionsForProfile = (profileId: string): Promise<ConditionResultResponse[]> => {
    return get(`/monitoring/conditions/${profileId}`)
        .then(extractBody);
}

export const monitoringApiClient = {
    getConditions: getConditions,
    getConditionsForProfile: getConditionsForProfile
}